import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';
import { validateBillable, saveBillable } from '@/js/modules/billable-utils';

export default class extends Controller {
  #sending = false;

  async send(event) {
    event.preventDefault();

    const link = event.currentTarget;
    if (this.#sending || link.classList.contains('button-disabled')) {
      return;
    }

    const form = link.closest('form');
    if (!form) {
      return;
    }

    if (!form.reportValidity()) {
      return;
    }

    this.#sending = true;
    try {
      const { valid, errorMessage } = await validateBillable(form);
      if (!valid) {
        if (errorMessage) {
          window.alert(errorMessage);
        }
        return;
      }

      if (await saveBillable(form)) {
        document.dispatchEvent(new CustomEvent('billable:saved'));
        await get(link.href, { responseKind: 'turbo-stream' });
      }
    } finally {
      this.#sending = false;
    }
  }
}
